<template>
  <div id="app">
    <div class="box">
      <router-view v-if="isRouterAlive" />
    </div>
  </div>
</template>

<script>
export default {
  name: "app",
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      isRouterAlive: true
    };
  },

  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    }
  }
};
</script>

<style lang="scss">
// #app {
//   width: 100vw;
//   height: 100vh;
//   // background-color: #fefefe;
// }

html {
  height: 100%;
  background-color: #ffffff;
}
body {
  margin: 0;
  padding: 0;
  height: 100%;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
  background: #fff;
  height: 100%;
  .box {
    // width: 100%;
    height: 100% !important;
  }
}
</style>
